import { Ref, ref, unref, watch } from 'vue'
import { getSettings, addSettings, updateSettingAPI, getAPIEnvironments } from '../../../data/pages/settings'
import { Setting } from '../../../models/setting'

export const useSettings = () => {
  const isLoading = ref(false)
  const settings = ref<Setting>()
  const environments = ref([])

  const fetch = async () => {
    isLoading.value = true
    const environmentsData = await getAPIEnvironments()
    environments.value = environmentsData.data
    const { data } = await getSettings()
    settings.value = data.id ? data : null
    isLoading.value = false
  }

  return {
    isLoading,
    settings,

    fetch,
    environments,
    async add(setting: Setting) {
      isLoading.value = true
      try {
        await addSettings(setting)
        await fetch()
      } catch (e) {
        throw e
      } finally {
        isLoading.value = false
      }
    },

    async update(setting: Setting) {
      isLoading.value = true
      try {
        await updateSettingAPI(setting)
        await fetch()
      } catch (e) {
        throw e
      } finally {
        isLoading.value = false
      }
    },
  }
}
